import { render, staticRenderFns } from "./DreamEdit.vue?vue&type=template&id=09e9f4f6&scoped=true&"
import script from "./DreamEdit.vue?vue&type=script&lang=ts&"
export * from "./DreamEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e9f4f6",
  null
  
)

export default component.exports